import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9023f828"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "text-size-14" }, [
  /*#__PURE__*/_createTextVNode("\n        お仕事をする上で経験や転職意欲の入力は必須です"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        入力することで以下のことがスムーズに行えます"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        ✓お仕事への応募"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        ✓事業所様とのお仕事の調整"),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("\n        ✓転職活動\n      ")
], -1))
const _hoisted_2 = { class: "mt-2" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { class: "mr-1 mb-1 text-size-14 text-mild" }, "サービス種類・経験", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "mb-2 text-size-14 text-gray-05" }, "\n        経歴を全て選択\n      ", -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InfoCard = _resolveComponent("InfoCard")!
  const _component_AppLabel = _resolveComponent("AppLabel")!
  const _component_AppFormSelect = _resolveComponent("AppFormSelect")!
  const _component_FormInvalidFeedback = _resolveComponent("FormInvalidFeedback")!
  const _component_ValidationProvider = _resolveComponent("ValidationProvider")!
  const _component_BCol = _resolveComponent("BCol")!
  const _component_FeatherIcon = _resolveComponent("FeatherIcon")!
  const _component_BRow = _resolveComponent("BRow")!
  const _component_TextAreaGroup = _resolveComponent("TextAreaGroup")!
  const _component_FormCheckboxGroup = _resolveComponent("FormCheckboxGroup")!
  const _component_ValidationField = _resolveComponent("ValidationField")!
  const _component_FormSelectGroup = _resolveComponent("FormSelectGroup")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_InfoCard, { "body-class": "p-2" }, {
      default: _withCtx(() => [
        _hoisted_1
      ], undefined, true),
      _: 1
    }),
    _createTextVNode(),
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createTextVNode(),
      _createVNode(_component_AppLabel, { variant: "red" }, {
        default: _withCtx(() => [
          _createTextVNode("必須")
        ], undefined, true),
        _: 1
      }),
      _createTextVNode(),
      _hoisted_4,
      _createTextVNode(),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.inputValues.experiences, (experience, i) => {
        return (_openBlock(), _createBlock(_component_BRow, {
          class: "mx-n2",
          key: i
        }, {
          default: _withCtx(() => [
            _createVNode(_component_BCol, {
              cols: "6",
              class: "px-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_ValidationProvider, {
                  name: "種類",
                  rules: "required",
                  vid: `experiences[${i}].service`,
                  modelValue: experience.service,
                  "onUpdate:modelValue": ($event: any) => ((experience.service) = $event)
                }, {
                  default: _withCtx((validationState) => [
                    _createVNode(_component_AppFormSelect, {
                      modelValue: experience.service,
                      "onUpdate:modelValue": ($event: any) => ((experience.service) = $event),
                      formOptions: 
                _ctx.isIncludeProductService(experience.service)
                  ? _ctx.options.experienceTypeOptionsByProduct
                  : _ctx.options.experienceTypeOptions
              ,
                      firstOption: "種類を選択",
                      onChange: ($event: any) => (_ctx.onChangeService(i)),
                      "validation-state": validationState,
                      excludeSelected: true,
                      selectedOptions: _ctx.selectedExperiences,
                      disabled: !_ctx.isIncludeProductService(experience.service)
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "formOptions", "onChange", "validation-state", "selectedOptions", "disabled"]),
                    _createTextVNode(),
                    _createVNode(_component_FormInvalidFeedback, {
                      "validation-state": validationState,
                      state: false
                    }, null, 8, ["validation-state"])
                  ]),
                  _: 2
                }, 1032, ["vid", "modelValue", "onUpdate:modelValue"])
              ], undefined, true),
              _: 2
            }, 1024),
            _createTextVNode(),
            _createVNode(_component_BCol, {
              cols: "4",
              class: "px-2"
            }, {
              default: _withCtx(() => [
                (!_ctx.isInexperienced(experience.service))
                  ? (_openBlock(), _createBlock(_component_ValidationProvider, {
                      key: 0,
                      name: "経験",
                      rules: "required",
                      vid: `experiences[${i}].stint`,
                      modelValue: experience.stint,
                      "onUpdate:modelValue": ($event: any) => ((experience.stint) = $event)
                    }, {
                      default: _withCtx((validationState) => [
                        _createVNode(_component_AppFormSelect, {
                          modelValue: experience.stint,
                          "onUpdate:modelValue": ($event: any) => ((experience.stint) = $event),
                          formOptions: _ctx.options.experienceStintOptions,
                          firstOption: "年数を選択",
                          "validation-state": validationState,
                          disabled: !_ctx.isIncludeProductService(experience.service)
                        }, null, 8, ["modelValue", "onUpdate:modelValue", "formOptions", "validation-state", "disabled"]),
                        _createTextVNode(),
                        _createVNode(_component_FormInvalidFeedback, {
                          "validation-state": validationState,
                          state: false
                        }, null, 8, ["validation-state"])
                      ]),
                      _: 2
                    }, 1032, ["vid", "modelValue", "onUpdate:modelValue"]))
                  : _createCommentVNode("", true)
              ], undefined, true),
              _: 2
            }, 1024),
            _createTextVNode(),
            _createVNode(_component_BCol, {
              cols: "2",
              class: "px-2",
              "align-self": "center"
            }, {
              default: _withCtx(() => [
                (i === 0)
                  ? (_openBlock(), _createBlock(_component_FeatherIcon, {
                      key: 0,
                      icon: "plus-circle",
                      class: _normalizeClass(["align-baseline", { 'text-gray-04': !_ctx.isSelectedBeforeExperience }]),
                      onClick: _ctx.addExperience
                    }, null, 8, ["class", "onClick"]))
                  : (_openBlock(), _createBlock(_component_FeatherIcon, {
                      key: 1,
                      icon: "minus-circle",
                      class: "align-baseline",
                      onClick: ($event: any) => (_ctx.removeExperience(i))
                    }, null, 8, ["onClick"]))
              ], undefined, true),
              _: 2
            }, 1024)
          ], undefined, true),
          _: 2
        }, 1024))
      }), 128))
    ]),
    _createTextVNode(),
    _createVNode(_component_ValidationProvider, {
      name: "自己PR",
      rules: "required|max:512",
      tag: "div",
      class: "mt-3",
      vid: "prComment",
      modelValue: _ctx.inputValues.prComment,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.inputValues.prComment) = $event))
    }, {
      default: _withCtx((validationState) => [
        _createVNode(_component_TextAreaGroup, {
          modelValue: _ctx.inputValues.prComment,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.inputValues.prComment) = $event)),
          appLabelText: "必須",
          label: "自己PR",
          placeholder: "経歴/現在の働き方、得意な業務、利用頻度、興味、挨拶言葉など",
          type: "text",
          "validation-state": validationState
        }, null, 8, ["modelValue", "validation-state"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createTextVNode(),
    _createVNode(_component_ValidationField, {
      label: "現在の働き方",
      rules: "required",
      tag: "div",
      class: "mt-3",
      name: "latestWorkStyle",
      modelValue: _ctx.inputValues.latestWorkStyle,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.inputValues.latestWorkStyle) = $event))
    }, {
      default: _withCtx((validationState) => [
        _createVNode(_component_FormCheckboxGroup, {
          label: "現在の働き方（複数可）",
          appLabelText: "必須",
          name: "latest",
          options: _ctx.options.workStyleOptions,
          modelValue: _ctx.inputValues.latestWorkStyle,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.inputValues.latestWorkStyle) = $event)),
          "validation-state": validationState,
          onChange: ($event: any) => (_ctx.onChangeWorkStyles($event, validationState.handleChange))
        }, null, 8, ["options", "modelValue", "validation-state", "onChange"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createTextVNode(),
    _createVNode(_component_ValidationProvider, {
      name: "転職意欲",
      rules: "required",
      tag: "div",
      class: "mt-3",
      vid: "jobChange",
      modelValue: _ctx.inputValues.jobChange,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.inputValues.jobChange) = $event))
    }, {
      default: _withCtx((validationState) => [
        _createVNode(_component_FormSelectGroup, {
          label: "転職意欲",
          appLabelText: "必須",
          modelValue: _ctx.inputValues.jobChange,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.inputValues.jobChange) = $event)),
          options: _ctx.options.jobChangeOptions,
          "validation-state": validationState
        }, null, 8, ["modelValue", "options", "validation-state"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createTextVNode(),
    _createVNode(_component_ValidationField, {
      label: "次の希望の働き方",
      rules: "required",
      tag: "div",
      class: "mt-3",
      name: "preferredWorkStyle",
      modelValue: _ctx.inputValues.preferredWorkStyle,
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.inputValues.preferredWorkStyle) = $event))
    }, {
      default: _withCtx((validationState) => [
        _createVNode(_component_FormCheckboxGroup, {
          label: "次の希望の働き方（複数可）",
          appLabelText: "必須",
          name: "preferred",
          options: _ctx.options.workStyleOptions,
          modelValue: _ctx.inputValues.preferredWorkStyle,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.inputValues.preferredWorkStyle) = $event)),
          "validation-state": validationState,
          onChange: ($event: any) => (_ctx.onChangeWorkStyles($event, validationState.handleChange))
        }, null, 8, ["options", "modelValue", "validation-state", "onChange"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}